document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.pdp-offers-carousel');
  if (!carousel) return;

  const container = carousel.querySelector('.scrollable-container');
  const leftArrow = carousel.querySelector('.left-arrow');
  const rightArrow = carousel.querySelector('.right-arrow');
  const offers = container.querySelectorAll('.offer-card');

  function getCardFullWidth(card) {
    const style = getComputedStyle(card);
    const width = card.offsetWidth;
    const marginRight = parseInt(style.marginRight) || 0;
    return width + marginRight;
  }

  const scrollAmount = offers.length > 0 ? getCardFullWidth(offers[0]) : 0;

  leftArrow.addEventListener('click', () => {
    // Calculate new scroll position
    const newScrollLeft = Math.max(container.scrollLeft - scrollAmount, 0);
    container.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    const newScrollLeft = Math.min(container.scrollLeft + scrollAmount, maxScrollLeft);
    container.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
  });

  function updateArrowsDisabledState() {
    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    leftArrow.disabled = container.scrollLeft <= 0;
    rightArrow.disabled = container.scrollLeft >= maxScrollLeft - 1;
  }

  container.addEventListener('scroll', updateArrowsDisabledState);
  updateArrowsDisabledState();
});
